<div class="animation-system-select-picture" fxLayout="column" fxLayoutGap="30px">
    <app-system-picture *ngIf="systemId" systemId="{{systemId}}" alt="{{alt}}"></app-system-picture>
    <app-system-picture *ngIf="systemId" systemId="payoneer"></app-system-picture>
    <app-system-picture *ngIf="systemId" systemId="palpal"></app-system-picture>
    <app-system-picture *ngIf="systemId" systemId="neteller"></app-system-picture>
    <app-system-picture *ngIf="systemId" systemId="skrill"></app-system-picture>
</div>
